var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobPurpleHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486.7 486.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efc6e8;}.cls-2{fill:#faecf7;}.cls-3{fill:#db8cd1;}.cls-4{fill:#e29fd9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m486.7,486.7H0c22.5-55.4,45.1-110.8,63.6-175.3,18.4-64.4,32.8-137.8,78.9-168.9,46.1-31,123.9-19.7,186.5-36.4,62.7-16.7,110.2-61.4,157.7-106.1v486.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m486.7,486.7H121.6c17-41.6,33.9-83.1,47.7-131.5,13.9-48.3,24.7-103.3,59.3-126.6,34.5-23.3,92.9-14.9,139.9-27.4,46.9-12.5,82.6-46,118.2-79.6v365.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m486.7,486.7h-243.4c11.3-27.7,22.6-55.4,31.8-87.6,9.3-32.2,16.5-69,39.5-84.5,23.1-15.5,61.9-9.9,93.3-18.2,31.3-8.4,55-30.7,78.8-53.1v243.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m486.7,486.7h-121.7c5.7-13.9,11.3-27.7,15.9-43.8,4.6-16.1,8.2-34.5,19.8-42.2,11.5-7.8,30.9-5,46.6-9.2,15.6-4.1,27.5-15.3,39.4-26.5v121.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobPurpleHalf);
export default __webpack_public_path__ + "static/media/blob_purple_half.1e122d68028bfb9335e3a6c569b00f94.svg";
export { ForwardRef as ReactComponent };